import {ApiInterface} from '@/plugins/core/api/interface';
import {getTimestamp} from '@/utils/utility-functions';

const apis: ApiInterface[] = [
  {
    name: 'portal',
    actions: [
      {
        name: 'logout',
        method: 'post',
        endpoint: '/api/internal/ssp_users/logout',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      },
    ],
  },
  {
    name: 'js_info',
    actions: [
      {
        name: 'static',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: () => {
          const timestamp = getTimestamp();
          return `/api/internal/${timestamp}/retrieve_js_info`;
        },
        static: true,
      },
      {
        name: 'get',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: () => {
          const timestamp = getTimestamp();
          return `/api/internal/${timestamp}/retrieve_js_info`;
        },
        static: false,
      },
    ],
  },
  {
    name: 'locale',
    actions: [
      {
        name: 'retrieve',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: (data) => {
          const timestamp = getTimestamp();
          return `/api/internal/cbjs/${timestamp}/translations?locale=${data.languageCode}`;
        },
      },
    ],
  },
];

export default apis;
